import React, { useState } from "react";
import { Button, Box, Typography } from "@mui/material";
// import "../App.css"; 


import { LocalTaxi, DirectionsCar, Flight, Hotel, EmojiPeople, Train } from "@mui/icons-material";

import TaxiComponent from "./Taxiservices";
import CarRentalSteps from "./taxione";
import DiscountInfo from "./taxitwo";
import AboutUs from "../AboutUs/Aboutus";

const serviceList = [
  { name: "Taxi Services", icon: <LocalTaxi className="service-icon" /> },
  { name: "Flight Booking", icon: <Flight className="service-icon" /> },
  { name: "Guide Services", icon: <EmojiPeople className="service-icon" /> },
  { name: "Car on Rent", icon: <DirectionsCar className="service-icon" /> },
  { name: "Railway Booking", icon: <Train className="service-icon" /> },
  { name: "Hotels Booking", icon: <Hotel className="service-icon" /> },
];

const OurServices = () => {
  const [activeService, setActiveService] = useState("Taxi Services");
  const [hoveredService, setHoveredService] = useState(null);

  return (
    <div className="services-container">
      
      {/* Heading */}

      <Box className="heading-container">

        <Typography variant="h2" className="main-heading">OUR</Typography>  
        <Typography variant="h3" className="sub-heading">Services</Typography>

      </Box>

      {/* Service Buttons (Horizontally Scrollable on Mobile) */}
      {/* <div className="service-buttons">
        {serviceList.map((service, index) => (
        
         <Button
            key={index}
            variant="contained"
            disableElevation
            sx={{backgroundColor:'black'}}
            className={`service-btn ${hoveredService === service.name || activeService === service.name ? "active" : ""}`}
            onMouseEnter={() => {
              setHoveredService(service.name);
              setActiveService("");
            }}


            onMouseLeave={() => {
              setHoveredService(null);
              setActiveService("Taxi Services");
            }}
          >

            {service.icon} <span className="service-text">{service.name}</span>
          </Button>
        ))}
      </div> */}

  <Box>      
  <AboutUs/>
  </Box>      
      
      
      <Box>
      <CarRentalSteps/>
      </Box>
      
       <DiscountInfo/>
      
      </div>
     
     );
     };

export default OurServices;
